'use client';

import type { EChartsOption } from 'echarts';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import type { EChartsReactProps } from 'echarts-for-react/lib/types';
import * as echarts from 'echarts/core';
import { BarChart, LineChart } from 'echarts/charts';
import {
  LegendComponent,
  GridComponent,
  TooltipComponent,
  TitleComponent,
  DatasetComponent,
} from 'echarts/components';
import {
  SVGRenderer,
} from 'echarts/renderers';

echarts.use([
  BarChart,
  LineChart,
  GridComponent,
  LegendComponent,
  TooltipComponent,
  TitleComponent,
  DatasetComponent,
  SVGRenderer,
]);

export const Chart = ({
  options,
  onEvents,
  ref,
}: {
  options: EChartsOption;
  onEvents?: EChartsReactProps['onEvents'];
  ref?: React.Ref<ReactEChartsCore>;
}) => {
  return (
    <ReactEChartsCore
      ref={ref}
      style={{
        height: '100%',
        width: '100%',
      }}
      echarts={echarts}
      notMerge
      lazyUpdate
      option={options}
      onEvents={onEvents}
    />
  )
};
